import { render, staticRenderFns } from "./SocialConnections.vue?vue&type=template&id=3dccd7ea&scoped=true&"
import script from "./SocialConnections.vue?vue&type=script&lang=ts&"
export * from "./SocialConnections.vue?vue&type=script&lang=ts&"
import style0 from "./SocialConnections.vue?vue&type=style&index=0&id=3dccd7ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dccd7ea",
  null
  
)

export default component.exports